import { createAction } from 'redux-actions'
import G from "../sonodalib/SlGlobal";

export const UPDATE_MOSHI = 'UPDATE_MOSHI'
const updateMoshiAC = createAction(UPDATE_MOSHI, entity => (entity));

export function updateMoshi(payload) {
	G.store.dispatch(updateMoshiAC(payload))
}